import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    ariaLabel: (isShare: boolean) => string;
    iconLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Aria label - changes based on whether viewing a share or locked account */
            ariaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (isShare: boolean): string => __intl__.intl().formatMessage({ id: "AccountLockingDialog.ariaLabel?c=2mhs40fj1b40d", defaultMessage: "{isShare, select, true {This Share is Unavailable} other {Your account is locked}}" }, { isShare: isShare }));
                },
                enumerable: true,
                configurable: true
            },
            /** Close button label */
            iconLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountLockingDialog.iconLabel?c=fpm3uod7zaal", defaultMessage: "close" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
